document.addEventListener('DOMContentLoaded', () => {
    const sliders =    document.querySelectorAll('.twz-element-imageslider__slider');

    sliders.forEach( slider => {

        const Flickity = require("flickity");

        if( slider.querySelectorAll(".slide").length > 1 ) {

            const flkty = new Flickity( slider, {
                autoPlay: 3000,
                // contain: true,
                draggable: true,
                percentPosition: true,
                pageDots: false,
                prevNextButtons: true,
            });
        }
    })
});